<p class="u-m-bottom--sm">{{ 'BOOKING.FIRST_CAMP.FIRST_CHOOSE' | translate }}</p>

<ivva-camp-form [priority]="1"></ivva-camp-form>

@if (form) {
	<form [formGroup]="form">
		<p class="u-title-sub u-m-top--md u-m-bottom--sm">{{ 'BOOKING.FIRST_CAMP.EXTRA_TITLE' | translate }}</p>

		<div class="u-row">
			<div class="u-col--12">
				<p class="u-text--medium">
					{{ 'BOOKING.FIRST_CAMP.EXTRA_DESCRIPTION' | translate }}
					<span class="u-text--sm u-text--grey-blue u-text--normal">(optioneel)</span>
				</p>
				<tvcore-input [maxChar]="MAX_CHARS_INFO" [showErrors]="showErrors" name="extraInfo" type="textarea"></tvcore-input>
			</div>
		</div>
	</form>
}
